import { PlusOutlined } from "@ant-design/icons";
import { Select, Checkbox, Input, Button } from "antd";
import { getCustomTagsByJob } from "api/candidate.api";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";

const SelectCustomTags = memo(({ handleTagChange, isAddingTag, validTags, jobId }: any) => {
    const [availableTags, setAvailableTags] = useState<any>([]);
    const [error, setError] = useState<string | null>(null);

    const fetchTags = useCallback(async () => {
        try {
            if (!jobId) return;

            const tags = await getCustomTagsByJob(Number(jobId));
            const customTags: any = tags?.map((tag: any) => ({
                label: tag.tag,
                value: tag.tag,
            })) || [];
            const mergedTags = [...customTags];
            const uniqueTags = Array.from(
                new Map(mergedTags.map((tag) => [tag.value, tag])).values()
            );

            setAvailableTags(Array.from(uniqueTags));
        } catch (err) {
            setError("Failed to load tags");
            setAvailableTags([]);
            console.error("Error fetching tags:", err);
        }
    }, [jobId]);

    const lastFetchedPool = useRef<number | null>(null);

    useEffect(() => {
        if (jobId) {
            fetchTags();
            lastFetchedPool.current = jobId;
        }
    }, [jobId, fetchTags]);

    return (
        <Select
            mode="tags"
            className="min-w-40"
            size="small"
            placeholder="Add tags"
            maxTagPlaceholder="Add tags"
            value={validTags}
            maxTagCount={0} // Hides selected tags from the input
            tagRender={() => <></>}
            menuItemSelectedIcon={null}
            loading={isAddingTag}
            disabled={isAddingTag}
            optionLabelProp="label"
            options={availableTags}
            autoClearSearchValue
            onDeselect={(value) => {
                handleTagChange(value);
            }}
            optionRender={(option) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                        checked={validTags.includes(option.value)}
                        onChange={() => handleTagChange(option.value)}
                        className="mr-2"
                    />
                    <span className="flex-grow" onClick={() => handleTagChange(option.value)}>
                        {option.label}
                    </span>
                </div>
            )}
            showSearch
        />
    );
});

export default SelectCustomTags;